export const getFileExtension = (contentType: string) => {
  return {
    'application/vnd.ms-excel.sheet.macroEnabled.12': 'xlsm',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/zip': 'zip'
  }[contentType];
};
